import "./MaintenancePage.css";
import logo from "../../assets/images/logo.png";

function MaintenancePage() {
  return (
    <div className="maintenance-page" role="status" aria-live="polite">
      <div className="maintenance-page__inner">
        <img
          loading="lazy"
          className="maintenance-page__logo"
          src={logo}
          alt=""
          width={180}
          height={80}
        />
        <h1 className="maintenance-page__title">Site under maintenance</h1>
        <p className="maintenance-page__text">
          We&apos;re making improvements. Please check back soon.
        </p>
      </div>
    </div>
  );
}

export default MaintenancePage;
